import React from 'react';
import ClassNames from 'classnames';
import UniqueId from 'utils/unique-id';
import Paper from 'components/paper/Paper';
import EnhancedTextarea from 'components/forms/enhanced-textarea/EnhancedTextarea';
import Transition from 'components/transition-groups/Transition';

export default React.createClass({

	propTypes: {
		errorText: React.PropTypes.string,
		floatingLabelText: React.PropTypes.string,
		hintText: React.PropTypes.string,
		id: React.PropTypes.string,
		multiLine: React.PropTypes.bool,
		onBlur: React.PropTypes.func,
		onChange: React.PropTypes.func,
		onFocus: React.PropTypes.func,
		onKeyDown: React.PropTypes.func,
		onEnterKeyDown: React.PropTypes.func,
		type: React.PropTypes.string,
		defaultValue: React.PropTypes.string,
		underlinePosition: React.PropTypes.oneOf(['top','bottom','none']),
		rounded: React.PropTypes.bool,
		status: React.PropTypes.oneOf(['success','alert','error','primary','secondary']),
		subtext: React.PropTypes.string,
		subtextPush: React.PropTypes.bool
	},

	getDefaultProps() {
		return {
			type: 'text',
			underlinePosition: 'bottom',
			rounded: true,
			topRounded: true,
			bottomRounded: true,
			status: 'primary',
			subtextPush: true
		};
	},

	getInitialState() {
		return {
			errorText: this.props.errorText,
			disabled: this.props.disabled,
			hasValue: this.props.value || this.props.defaultValue ||
				(this.props.valueLink && this.props.valueLink.value),
			status: this.props.status
		};
	},

	componentWillReceiveProps(nextProps) {
		let hasErrorProp = nextProps.hasOwnProperty('errorText');
		let hasValueLinkProp = nextProps.hasOwnProperty('valueLink');
		let hasValueProp = nextProps.hasOwnProperty('value');
		let hasNewDefaultValue = nextProps.defaultValue !== this.props.defaultValue;
		let newState = {};

		if (hasValueProp) {
			newState.hasValue = nextProps.value;
		} else if (hasValueLinkProp) {
			newState.hasValue = nextProps.valueLink.value;
		} else if (hasNewDefaultValue) {
			newState.hasValue = nextProps.defaultValue;
		}

		if (hasErrorProp) newState.errorText = nextProps.errorText;
		if (newState) this.setState(newState);
	},

	render() {
		let {
			className,
			errorText,
			floatingLabelText,
			hintText,
			id,
			multiLine,
			onBlur,
			onChange,
			onFocus,
			type,
			disabled,
			topRounded,
			bottomRounded } = this.props;

		let classes = ClassNames(
			'lui-text-field', 
			`lui-is-${this.state.status}`,
			this.props.innerClassName, {
			'lui-has-error': this.state.errorText,
			'lui-has-floating-labels': floatingLabelText,
			'lui-has-value': this.state.hasValue,
			'lui-is-disabled': disabled,
			'lui-is-focused': this.state.isFocused,
			'lui-is-multiLine': multiLine,
			'lui-is-top-rounded': topRounded,
			'lui-is-bottom-rounded': bottomRounded
		});

		let inputId = id || UniqueId.generate();

		let subtext;

		if (this.state.errorText) {
			subtext = this.state.errorText;
		} else {
			subtext = this.props.subtext;
		}

		// let subtextElement = this.state.errorText || this.props.subtext ? (
			
		// ) : null;

		let hintTextElement = hintText ? (
			<div className="lui-text-field-hint">{hintText}</div>
		) : null;

		let floatingLabelTextElement = floatingLabelText ? (
			<label
				className="lui-text-field-floating-label"
				htmlFor={inputId}>
				{floatingLabelText}
			</label>
		) : null;

		let inputProps;
		let inputElement;

		inputProps = {
			ref: 'input',
			className: 'lui-text-field-input',
			id: inputId,
			onBlur: this._handleInputBlur,
			onFocus: this._handleInputFocus,
			onKeyDown: this._handleInputKeyDown,
			onChange: this._handleInputChange
		};

		if (!this.props.hasOwnProperty('valueLink')) {
			inputProps.onChange = this._handleInputChange;
		}

		inputElement = multiLine ? (
			<EnhancedTextarea
				{...this.props}
				{...inputProps}
				onHeightChange={this._handleTextAreaHeightChange}
				textareaClassName="lui-text-field-textarea" />
		) : (
			<input
				{...this.props}
				{...inputProps}
				type={this.props.type} />
		);

		let underline;
		let overline;

		switch (this.props.underlinePosition) {
			case "top":
				overline = (<div className="lui-text-field-focus-overline" />)
				break;
			case "bottom":
				underline = (<div className="lui-text-field-focus-underline" />)
				break;
			case "none":
				break;
		};

		let wrapperStyles;

		if (this.props.subtextPush && this.state.errorText || this.props.subtext) {
			wrapperStyles = {
				marginBottom: '20px'
			}
		}

		let subtextWrapperClassName = ClassNames("lui-text-field-subtext-wrapper",{
			"lui-has-subtext" : this.state.errorText || this.props.subtext
		})

		return (
			<div style={wrapperStyles} className="lui-text-field-wrapper">
				<Paper 
					rounded={this.props.rounded} 
					innerClassName={classes}
					topRounded={this.props.topRounded}
					bottomRounded={this.props.bottomRounded}
					depth={this.props.depth} >

					{overline}

					<div>
						{floatingLabelTextElement}
						{hintTextElement}
						{inputElement}
					</div>

					{underline}
					
					<div className={subtextWrapperClassName}>
						<div className="lui-text-field-subtext">{subtext}</div>
					</div>

				</Paper>
			</div>
		);
	},

	blur() {
		if (this.isMounted()) this._getInputNode().blur();
	},

	clearValue() {
		this.setValue('');
	},

	focus() {
		if (this.isMounted()) this._getInputNode().focus();
	},

	getValue() {
		return this.isMounted() ? this._getInputNode().value : undefined;
	},

	setErrorText(newErrorText) {
		if (process.NODE_ENV !== 'production' && this.props.hasOwnProperty('errorText')) {
			console.error('Cannot call TextField.setErrorText when errorText is defined as a property.');
		} else if (this.isMounted()) {
			this.setState({errorText: newErrorText});
		}
	},

	setValue(newValue) {
		if (process.NODE_ENV !== 'production' && this._isControlled()) {
			console.error('Cannot call TextField.setValue when value or valueLink is defined as a property.');
		} else if (this.isMounted()) {
			this._getInputNode().value = newValue;
			this.setState({hasValue: newValue});
		}
	},

	_getInputNode() {
		return this.props.multiLine ?
			this.refs.input.getInputNode() : this.refs.input.getDOMNode();
	},

	_handleInputBlur(e) {
		this.setState({isFocused: false});
		if (this.props.onBlur) this.props.onBlur(e);
	},

	_handleInputChange(e) {
		this.setState({hasValue: e.target.value});
		if (this.props.onChange) this.props.onChange(e);
	},

	_handleInputFocus(e) {
		this.setState({isFocused: true});
		if (this.props.onFocus) this.props.onFocus(e);
	},

	_handleInputKeyDown(e) {
		if (e.keyCode === 13 && this.props.onEnterKeyDown) this.props.onEnterKeyDown(e);
		if (this.props.onKeyDown) this.props.onKeyDown(e);
	},

	_handleTextAreaHeightChange(e, height) {
		let newHeight = height + 24;
		if (this.props.floatingLabelText) newHeight += 24;
		this.getDOMNode().style.height = newHeight + 'px';
	},

	_isControlled() {
		return this.props.hasOwnProperty('value') ||
			this.props.hasOwnProperty('valueLink');
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/forms/text-field/TextField.js
 **/